var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4518 0.966258C12.7121 1.22661 12.7121 1.64872 12.4518 1.90907L4.4379 9.92294L0.195262 5.6803C-0.0650874 5.41995 -0.0650874 4.99784 0.195262 4.73749C0.455612 4.47714 0.877722 4.47714 1.13807 4.73749L4.4379 8.03733L11.509 0.966258C11.7693 0.705909 12.1914 0.705909 12.4518 0.966258Z",
    fill: "#0B907B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCheckGreen);
export default __webpack_public_path__ + "static/media/right-check-green.349e2006f3b2701223204ad1fb81a3a7.svg";
export { ForwardRef as ReactComponent };